import React from 'react';
import PropTypes from 'prop-types';
import { SERVICE_STATUS } from '@bagonboard/wiseman';

import { Text } from './style';

const { CANCELLED, DECLINED } = SERVICE_STATUS;

const Code = ({ original: { status }, value }) => (
  <Text cancelled={[CANCELLED, DECLINED].includes(status)}>{value}</Text>
);
Code.propTypes = {
  classes : PropTypes.shape({}).isRequired,
  original: PropTypes.shape({
    status: PropTypes.string,
  }),
  value: PropTypes.string,
};
Code.defaultProps = {
  original: {},
  value   : '',
};

export default Code;
